import { Link } from 'react-router-dom';
import { useAuth } from '@repletoryreach/sdk-auth';
import { Group, Text, Button } from '@repletoryreach/sdk-ui';
import { Alert } from '@repletoryreach/sdk-ui/data-display';
import { useT } from '../../i18n/I18nProvider';
import { formatDate } from '../../lib/format';

/** On every page while the account is closing (2 October 2026), so nobody is surprised on the day. */
export function ClosingBanner() {
  const t = useT();
  const { user } = useAuth();
  const at = user?.org.closes_at;
  if (!at) return null;
  return (
    <div style={{ marginBottom: 16 }}>
      <Alert color="red" variant="light">
        <Group justify="space-between" wrap="wrap" gap="sm">
          <Text fz="sm">{t('settings.close.banner', { date: formatDate(at) })}</Text>
          {user?.role === 'owner' && <Link to="/settings/organisation"><Button size="xs" variant="default">{t('settings.close.keep')}</Button></Link>}
        </Group>
      </Alert>
    </div>
  );
}
